
import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'danger' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  leftIcon?: React.ReactNode;
}

export const Button: React.FC<ButtonProps> = ({ children, variant = 'primary', size = 'md', leftIcon, ...props }) => {
  const baseClasses = 'inline-flex items-center justify-center rounded-xl font-bold focus:outline-none focus:ring-2 focus:ring-offset-2 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed active:scale-95 dark:focus:ring-offset-slate-950';

  const variantClasses = {
    primary: 'border border-transparent bg-indigo-600 text-white shadow-lg hover:bg-indigo-700 hover:shadow-indigo-200 focus:ring-indigo-500 dark:bg-sky-500 dark:hover:bg-sky-400 dark:hover:shadow-sky-950/30 dark:focus:ring-sky-400',
    secondary: 'border border-gray-300 bg-white text-gray-900 shadow-sm hover:border-gray-400 hover:bg-gray-50 focus:ring-gray-400 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-100 dark:hover:border-slate-500 dark:hover:bg-slate-800 dark:focus:ring-slate-500',
    danger: 'border border-red-200 bg-red-50 text-red-700 hover:bg-red-100 focus:ring-red-500 dark:border-red-900/70 dark:bg-red-950/30 dark:text-red-200 dark:hover:bg-red-950/50',
    outline: 'border border-indigo-600 bg-transparent text-indigo-600 hover:bg-indigo-50 dark:border-sky-500 dark:text-sky-300 dark:hover:bg-sky-950/30'
  };

  const sizeClasses = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-5 py-2.5 text-sm',
    lg: 'px-6 py-3 text-base',
  };

  return (
    <button className={`${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${props.className || ''}`} {...props}>
      {leftIcon && <span className="mr-2">{leftIcon}</span>}
      {children}
    </button>
  );
};
